import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ClassNames from 'classnames';
import Dictionary from '../../../model/Dictionary';
import './SelectedPassengers.css';

class SelectedPassengers extends Component {
  static propTypes = {
    flight: PropTypes.object,
    allPassengers: PropTypes.arrayOf(PropTypes.object),
  };

  getNumberOfPassengers = () => {
    if (!this.props.allPassengers || !this.props.allPassengers.length) {
      return { selectedInfants: 0, selectedAdults: 0 };
    }
    let selectedInfants = 0;
    let selectedAdults = 0;
    this.props.allPassengers.map(fullPassengerInfo => {
      this.props.flight.passengers.find(passenger => {
        if (passenger.selected && passenger.id === fullPassengerInfo.id) {
          selectedInfants = fullPassengerInfo.infant ? ++selectedInfants : selectedInfants;
          selectedAdults = !fullPassengerInfo.infant ? ++selectedAdults : selectedAdults;
        }
      });
    });

    return {
      selectedInfants,
      selectedAdults,
    };
  };

  render () {
    const { selectedInfants, selectedAdults } = this.getNumberOfPassengers();
    const { flight } = this.props;
    let adults = parseInt(flight.adults, 10);
    let infants = parseInt(flight.infants, 10);

    return (
      <div className='selected-passengers'>
        {Dictionary.youHaveSelected}
        <span
          className={ClassNames({
            success: selectedAdults <= adults,
            error: selectedAdults > adults,
          })}
        >
          {Dictionary.translateNumberOfAdults(selectedAdults, adults)}
        </span>
        {Dictionary.and}
        <span
          className={ClassNames({
            success: selectedInfants <= infants,
            error: selectedInfants > infants,
          })}
        >
          {Dictionary.translateNumberOfInfants(selectedInfants, infants)}
        </span>
      </div>
    );
  }
}

export default SelectedPassengers;



// WEBPACK FOOTER //
// ./src/components/passengers/selectedPassengers/SelectedPassengers.js